import http from "./httpService";

const apiEndpoint = http.apiUrl + "contact-us";

// service is used to call contact us api
export function contactUs(data) {
  return http.post(apiEndpoint, data);
}
